<ul class="no-list-style">
  <li *ngFor="let cat of groupedServices; let first = first" [class.ps-xsmall-t]="!first">
    <div class="flex flex--middle">
      <fcom-icon [name]="cat.icon" class="icon-medium ms-xsmall-r"></fcom-icon>
      <div class="font-body-1 medium-type">
        {{ 'MMB.includedProducts.serviceCategory.' + cat.key + '.title' | finLocalization }}
      </div>
    </div>

    <ul class="accommodate-icon list-disc-style">
      <li *ngFor="let service of cat.services">
        <div class="flex flex--wrap flex--align-start flex--self-stretch">
          <span class="regular-type mr-xsmall-r">
            {{
              service.includedInTierBenefit
                ? service.displayName
                : ('MMB.includedProducts.' + service.subCategory + '.text'
                  | finLocalization
                    : {
                        seatNumber: service.seatNumber,
                        amount: service.quantity,
                        weight: service.parameters?.baggageWeight,
                        displayName: service.displayName
                      }
                  | finEmpty: service.displayName)
            }}
          </span>
          <fcom-chip *ngIf="cat.tierLevel && service.includedInTierBenefit">
            <fcom-icon [name]="'finnair-plus'" class="icon-medium ms-xxsmall-r"></fcom-icon>
            <span class="regular-type">{{
              'MMB.includedProducts.chip.text' | finLocalization: { tier: cat.tierLevel }
            }}</span>
          </fcom-chip>
        </div>
      </li>
    </ul>
  </li>
</ul>
